import HeartWithPerson from "./heart-with-person.svg";
export default HeartWithPerson;
